import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import * as ApiServiceProxies from './service-proxies';
import { AbpHttpInterceptor } from 'abp-ng2-module';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,

        ApiServiceProxies.CompanyServiceProxy,
        ApiServiceProxies.WarehouseServiceProxy,
        ApiServiceProxies.ProductServiceProxy,
        ApiServiceProxies.ClientServiceProxy,
        ApiServiceProxies.CommonServiceProxy,
        ApiServiceProxies.ErpServiceProxy,
        ApiServiceProxies.WorkServiceProxy,
        ApiServiceProxies.OrderServiceProxy,
        ApiServiceProxies.WaybillServiceProxy,
        ApiServiceProxies.DashboardServiceProxy,
        ApiServiceProxies.StockTakingServiceProxy,
        ApiServiceProxies.PrintingServiceProxy,
        ApiServiceProxies.FileServiceProxy,
        ApiServiceProxies.ProductionServiceProxy,
        ApiServiceProxies.DeliveryServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
